import type {
  PageContextClient,
} from 'vike/types';

export const onPageTransitionStart = (pageContext: Partial<PageContextClient>) => {
  console.log('Page transition start');
  console.log('pageContext.isBackwardNavigation', pageContext.isBackwardNavigation);
};
